import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a31d91c6-928d-4105-9cc7-4850ef18f1bb/artifacts/zj9kpzwc_JD%20Design%20Haus%20logo%20in%20grayscale%20%281%29.png";
const JAMIE_IMG = "https://customer-assets.emergentagent.com/job_elevated-spaces-1/artifacts/7tqnypay_Jamiephoto.png";

const LINKS = [
  { label: "Let's Work Together", href: "/contact", desc: "Start your dream project" },
  { label: "Schedule a Call", href: "/contact", desc: "Book a consultation" },
  { label: "Visit Website", href: "/", desc: "jdesignhaus.com" },
  { label: "Portfolio", href: "/portfolio", desc: "View our work" },
];

export default function LinksPage() {
  const origin = typeof window !== "undefined" ? window.location.origin : "";

  return (
    <div
      data-testid="links-page"
      className="min-h-screen bg-onyx flex flex-col items-center px-6 py-12 relative overflow-hidden"
    >
      {/* Subtle grain */}
      <div className="absolute inset-0 opacity-[0.03] bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIj48ZmlsdGVyIGlkPSJhIiB4PSIwIiB5PSIwIj48ZmVUdXJidWxlbmNlIGJhc2VGcmVxdWVuY3k9Ii43NSIgc3RpdGNoVGlsZXM9InN0aXRjaCIgdHlwZT0iZnJhY3RhbE5vaXNlIi8+PC9maWx0ZXI+PHJlY3Qgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiIGZpbHRlcj0idXJsKCNhKSIgb3BhY2l0eT0iMC4wNSIvPjwvc3ZnPg==')]" />

      <div className="relative z-10 w-full max-w-md flex flex-col items-center">
        {/* Profile Photo */}
        <motion.div
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
          className="w-28 h-28 rounded-full overflow-hidden border-2 border-taupe/30 mb-5"
        >
          <img
            src={JAMIE_IMG}
            alt="Jamie Weaver"
            className="w-full h-full object-cover"
            style={{ objectPosition: "center 15%" }}
          />
        </motion.div>

        {/* Name & Handle */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="text-center mb-3"
        >
          <h1 className="font-serif text-2xl text-bone font-light tracking-tight">
            J Design Haus
          </h1>
        </motion.div>

        <motion.a
          href="https://www.instagram.com/jdesignhaus"
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="text-sm text-bone hover:text-taupe transition-colors mb-2"
        >
          @jdesignhaus
        </motion.a>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.55, ease: [0.16, 1, 0.3, 1] }}
          className="text-xs tracking-[0.25em] uppercase text-bone/80 mb-10 text-center"
        >
          Elevated Spaces. Crafted with Intention.
        </motion.p>

        {/* Links */}
        <div className="w-full flex flex-col gap-3 mb-10">
          {LINKS.map((link, i) => (
            <motion.a
              key={link.label}
              href={`${origin}${link.href}`}
              data-testid={`link-${link.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.8,
                delay: 0.65 + i * 0.12,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="group w-full border border-bone/30 hover:border-taupe/50 px-6 py-5 flex items-center justify-between transition-all duration-500 hover:bg-bone/5"
            >
              <div>
                <p className="text-base font-normal text-bone group-hover:text-taupe transition-colors">
                  {link.label}
                </p>
                <p className="text-xs text-bone/80 font-light mt-0.5">
                  {link.desc}
                </p>
              </div>
              <ArrowUpRight
                size={16}
                className="text-bone/80 group-hover:text-taupe transition-colors"
              />
            </motion.a>
          ))}
        </div>

        {/* Website URL */}
        <motion.a
          href={origin}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.3 }}
          data-testid="link-website-url"
          className="group w-full bg-bone text-onyx px-6 py-4 flex items-center justify-center gap-2 transition-all duration-500 hover:bg-taupe hover:text-bone mb-10"
        >
          <span className="text-sm tracking-[0.15em] uppercase font-normal">
            www.jdesignhaus.com
          </span>
          <ArrowUpRight size={14} />
        </motion.a>

        {/* Scottsdale */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.5 }}
          className="text-[10px] tracking-[0.3em] uppercase text-bone/60"
        >
          Scottsdale, AZ
        </motion.p>
      </div>
    </div>
  );
}
